import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-gradient-to-b from-foreground-900 to-foreground-950 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-[1400px] mx-auto">
        {/* Top content */}
        <div className="mb-20">
          <span className="inline-block px-4 py-1.5 bg-primary-200/20 text-primary-200 text-xs font-semibold rounded-full mb-6">
            /// About The Resource
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 max-w-3xl leading-tight">
            What Is Superbuy Spreadsheet &amp; Why It Matters
          </h2>
          <div className="mt-8 max-w-2xl">
            <p className="text-background-50/70 text-base md:text-lg leading-relaxed">
              The Superbuy Spreadsheet is a structured resource system designed to help international shoppers discover products, compare options, review quality information, and organize purchases from platforms like Taobao, Weidian, and 1688. Whether you are a beginner looking for your first haul or an experienced buyer searching for hidden gems, this spreadsheet streamlines the entire research process.
            </p>
            <p className="text-background-50/60 text-base leading-relaxed mt-4">
              Unlike traditional searching where you spend hours scrolling through listings, the Superbuy Spreadsheet organizes thousands of verified finds into intuitive categories — making product discovery faster, smarter, and more reliable.
            </p>
          </div>

          {/* Comparison table */}
          <div className="mt-12 overflow-x-auto">
            <table className="w-full max-w-2xl text-left border-collapse">
              <thead>
                <tr className="border-b border-background-50/10">
                  <th className="py-3 pr-6 text-sm font-semibold text-background-50/80 whitespace-nowrap">Feature</th>
                  <th className="py-3 pr-6 text-sm font-semibold text-background-50/50 whitespace-nowrap">Traditional Search</th>
                  <th className="py-3 text-sm font-semibold text-accent-300 whitespace-nowrap">Superbuy Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-50/5">
                  <td className="py-3 pr-6 text-sm text-background-50/80">Product Discovery</td>
                  <td className="py-3 pr-6 text-sm text-background-50/40">Slow manual searching</td>
                  <td className="py-3 text-sm text-background-50/80">Organized database</td>
                </tr>
                <tr className="border-b border-background-50/5">
                  <td className="py-3 pr-6 text-sm text-background-50/80">Comparison</td>
                  <td className="py-3 pr-6 text-sm text-background-50/40">Difficult</td>
                  <td className="py-3 text-sm text-background-50/80">Easy side-by-side</td>
                </tr>
                <tr className="border-b border-background-50/5">
                  <td className="py-3 pr-6 text-sm text-background-50/80">Research Time</td>
                  <td className="py-3 pr-6 text-sm text-background-50/40">Hours per item</td>
                  <td className="py-3 text-sm text-background-50/80">Minutes per item</td>
                </tr>
                <tr>
                  <td className="py-3 pr-6 text-sm text-background-50/80">Beginner Experience</td>
                  <td className="py-3 pr-6 text-sm text-background-50/40">Confusing</td>
                  <td className="py-3 text-sm text-background-50/80">Simple workflow</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Bottom split layout */}
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <img
              src="https://readdy.ai/api/search-image?query=Artfully%20arranged%20fashion%20pieces%20with%20leather%20sneakers%2C%20woven%20caps%20and%20minimalist%20accessories%20on%20light%20travertine%20stone%20surface%2C%20soft%20morning%20light%20casting%20delicate%20shadows%2C%20editorial%20product%20styling%20with%20organic%20botanical%20accents%2C%20warm%20earthy%20palette%20with%20subtle%20olive%20and%20sand%20tones%2C%20refined%20lifestyle%20photography&width=600&height=600&seq=about-v2-product-display&orientation=squarish"
              alt="Superbuy Spreadsheet product research and discovery"
              title="Superbuy Spreadsheet product resources"
              className="rounded-2xl w-full max-w-md object-cover"
            />
          </div>
          <div className="lg:w-3/5">
            <span className="font-heading text-8xl md:text-9xl font-bold text-background-50/15 leading-none block">
              01
            </span>
            <div className="mt-4">
              <p className="text-background-50/60 text-base leading-relaxed max-w-lg">
                Dive deeper into how the Superbuy Spreadsheet can transform your shopping experience. Our comprehensive guide covers everything from beginner setup to advanced product research techniques used by thousands of international shoppers.
              </p>
              <Link
                to="/superbuy-spreadsheet-complete-guide"
                className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 font-semibold text-sm rounded-full hover:bg-background-100 transition-all whitespace-nowrap"
              >
                Read Full SEO Guide
                <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}